import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

userInformationStyles.userInformationTitle = {
    variant: "h4",
    css: css`
        color: ${getColor("text.main")};
    `,
};
userInformationStyles.userInformationGridItem = {
    width: 12,
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
userInformationStyles.changePasswordLink = {
    css: css`
        margin-left: 10px;
        &:hover {
            text-align: center;
            text-decoration-line: underline;
        }
    `,
};
